<template lang="pug">
.yc-text-field(v-on="on")
  v-text-field(v-model="modelValue" :label="label" :placeholder="placeholder" filled rounded hide-details="auto" :hide-details="hideDetails" :rules="rules" :type="type" :persistent-hint="hint.lengt > 0" :hint="hint" :prefix="prefix" :readonly="readonly" :validate-on-blur="validateOnBlur" :autofocus="autofocus" :disabled="disabled")
    template(v-if="prependIcon" v-slot:prepend-inner)
      v-icon.mt-n2.mr-2(:color="modelValue ? 'primary700' : 'primary400'" size="18") {{ prependIcon }}
    template(v-slot:append v-if="calendar")
      eva-icon(name="calendar-outline" fill="#848484")
</template>

<script>

export default {
  name: 'YcTextField',
  model: {
    event: 'change'
  },
  props: {
    value: {
      default: null
    },
    label: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    hint: {
      default: ''
    },
    prefix: {
      default: ''
    },
    prependIcon: {
      default: ''
    },
    calendar: {
      default: false
    },
    readonly: {
      default: false
    },
    type: {
      default: 'text'
    },
    validateOnBlur: {
      default: false
    },
    autofocus: {
      default: false
    },
    disabled: {
      default: false
    },
    hideDetails: {
      default: false
    },
    rules: {
      default: () => []
    },
    on: {
      default: null
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('change', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input .warning-icon {
    display: none;
  }
  .v-input.error--text .warning-icon {
    display: unset !important;
  }
  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 8px 16px;
  }
  .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    align-items: center;

    label {
      font-size: 16px !important;
      letter-spacing: -0.011em !important;
      margin-top: 6px !important;
    }
  }
  .v-text-field--filled {
    .v-input__slot{
      background: #FFF !important;
      border: 1px solid #c1c1c1 !important;
      border-radius: 10px;
      max-height: 48px;
      min-height: 48px;
      padding-left: 16px;
    }
    :not(.v-text-field--single-line) input {
      margin-top: 19px;
      padding: 0;
    }
    .v-label {
      top: unset !important;
      color: #848484;
      font-weight: 400 !important;
    }
    .v-label--active {
      transform: translateY(-10px) scale(0.75);
      color: #848484 ;
    }
  }
  .v-input--has-state {
    .v-label {
      color: #CD3300 !important;
    }
    .v-input__slot {
      border: 1px solid #CD3300 !important;
    }
    .error--text {
      color: #CD3300 !important;
    }
  }
  .v-input--has-state.v-input--is-focused {
    .v-label {
      color: #CD3300 !important;
    }
    .v-input__slot {
      border: 1.5px solid #CD3300 !important;
    }
  }
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #333;
    caret-color: #333;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .theme--light.v-input.error--text input,
  .theme--light.v-input.error--text textarea {
    color: #CD3300 !important;
    caret-color: #CD3300;
  }
  .v-input--is-focused {
    .v-label{
      color: #848484 !important;
    }
    .v-input__slot {
      border: 1.5px solid #333 !important;
    }
  }
  .v-text-field--enclosed .v-input__append-inner {
    margin: auto 0 !important;
  }
  .mdi::before {
    font-size: 20px;
    color: #333;
  }
  .v-text-field .v-input__control .v-input__slot {
    min-height: 56px !important;
    display: flex !important;
  }
}
</style>
